import { gql } from "@apollo/client";

export const GET_INITIATIVE_SENT_INVITES = gql`
  query GetInitiativeInvites($organizationId: String!) {
    getInitiativeInvites(organizationId: $organizationId) {
      id
      initiativeId
      invitedOrganizationId
      status
      createdAt
      initiative {
        name
        id
        description
        address
        service {
          name
        }
      }
      organization {
        id
        name
        description
        locations {
          address
          city
          country
        }
      }
    }
  }
`;
